"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeatureFlag = useFeatureFlag;
const growthbook_react_1 = require("@growthbook/growthbook-react");
const defaultFlags = {
    returnsEnabled: false,
    machineConfigEnabled: false,
    advertisingEnabledVending: false,
};
function useFeatureFlag(key) {
    return (0, growthbook_react_1.useFeatureValue)(key, defaultFlags[key]);
}
